import {Notification} from 'element-ui'

/**
 * 'Errors.service'
 * @version 1.0.0
 * @author Fernando Torres
 * @copyright Marciano Studio S.C., 2018
 */

const errorsCatalog = {
  400: {
    'DEFAULT': {
      title: 'Error en la transacción',
      description: 'Hubo un error al realizar la transacción. Por favor intente nuevamente.'
    },
    'UNAUTHORIZED_TRANSACTION': {
      title: 'Transacción rechazada',
      description: 'La transacción fue rechazada por el sistema'
    },
    'UNAUTHORIZED_TRANSACTION_00005': {
      title: 'Transacción rechazada',
      description: 'La tarjeta no puede tener 2 traspasos'
    },
    'UNAUTHORIZED_TRANSACTION_00004': {
      title: 'Transacción rechazada',
      description: 'El número de tarjeta IUT no existe'
    },
    'UNAUTHORIZED_TRANSACTION_00008': {
      title: 'Transacción rechazada',
      description: ' El importe del depósito excede el límite de los $2000 pesos en la tarjeta'
    },
    'UNAUTHORIZED_TRANSACTION_00003': {
      title: 'Transacción rechazada',
      description: ' El IUT de la tarjeta origen no existe'
    },
    'INTERNAL_API_ERROR': {
      title: 'Servicio no disponible',
      description: 'Intente realizar la operación nuevamente.'
    }
  },
  401: {
    'AUTH_TOKEN_COMPROMISED': {
      title: 'Sesión comprometida',
      description: 'Se han utilizado sus credenciales para iniciar sesión desde otro equipo.'
    },
    'AUTH_TOKEN_REVOKED': {
      title: 'Sesión cerrada',
      description: 'Debe de autenticarse nuevamente para utilizar la plataforma.'
    },
    'AUTH_TOKEN_EXPIRED': {
      title: 'Sesión expirada',
      description: 'Su sesión ha expirado. Debe de autenticarse nuevamente para utilizar la plataforma.'
    },
    'AUTH_TOKEN_INVALID': {
      title: 'Sesión incorrecta',
      description: 'No reconocemos su sesión. Debe de autenticarse nuevamente para utilizar la plataforma.'
    }
  },
  403: {
    'NOT_ALLOWED': {
      title: 'No permitido',
      description: 'No tienes permisos para ejecutar esta acción'
    }
  },
  404: {
    'DEFAULT': {
      title: 'Petición no encontrada',
      description: 'No se encontró la petición en el servidor'
    },
    'NOT_FOUND': {
      title: 'Petición no encontrada',
      description: 'No se encontró la petición en el servidor'
    }
  },
  406: {
    'DEFAULT': {
      title: 'Petición no encontrada',
      description: 'No se encontró la petición en el servidor'
    },
    '99': {
      title: 'La carpeta ya existe',
      description: 'Existe una carpeta con el mismo nombre en esta ubicación'
    }
  },
  422: {
    'DEFAULT': {
      title: 'Errores de validación',
      description: 'Existen errores de validación en la forma'
    },
    '100': {
      title: 'Errores de validación',
      description: 'Existen errores de validación en la forma'
    }
  },
  500: {
    'DEFAULT': {
      title: 'Error Desconocido',
      description: 'Hubo un error al tratar de ejecutar su operación'
    }
  }
}
/**
 * Push a notification error to the client app
 * if the API server throws an error.
 * @param httpErrorResponse
 */
export default (httpErrorResponse) => {
  let notification = {
    title: 'Error en el servidor',
    message: 'Sucedió un error al contactar al servidor, por favor, nuevamente.',
    type: 'error'
  }
  if (httpErrorResponse === undefined) {
    notification.title = 'Error de comunicación'
    notification.message = 'No tiene acceso a internet o el servidor no responde'
  } else {
    let errorCode = httpErrorResponse.data.code || 'DEFAULT'
    if (errorsCatalog[httpErrorResponse.status]) {
      notification.title = errorsCatalog[httpErrorResponse.status][errorCode].title
      notification.message = errorsCatalog[httpErrorResponse.status][errorCode].description
    }
  }
  Notification(notification)
}



// WEBPACK FOOTER //
// ./src/services/http-error-notification.service.js